import React, { useContext, useEffect, useState } from 'react';
import { useLazyQuery, useMutation } from '@apollo/client';
import { getPreset } from 'gqlQueries/filterQueries';

const errorMessage: string = 'Something went wrong!';

function useFetchSinglePreset({ onComplete, onError }: { onComplete: Function; onError: Function }) {
    const [loading, setLoading] = useState<boolean>(false);

    //To fetch dim
    const [fetchSinglePreset, { data: timePeriod, loading: timePeriodLoading, error: timePeriodError }] = useMutation(
        getPreset,
        {
            onCompleted: onFetchComplete,
            onError: onFetchError,
        },
    );

    //called when fetching is complete
    function onFetchComplete(payload: any) {
        try {
            const { fetchUserPreset } = payload;
            onComplete(fetchUserPreset);
        } catch (error) {
            onError(error);
            console.error(errorMessage, error);
        } finally {
            // setLoading(false);
        }
    }

    //called when API throws an error
    function onFetchError(error: any = errorMessage) {
        onError(error);
        setLoading(false);
    }

    return {
        loading,
        setLoading,
        fetchSinglePreset: (variables: any) => {
            setLoading(true);
            fetchSinglePreset(variables);
        },
    };
}

export default useFetchSinglePreset;
